export default __webpack_public_path__ + "static/media/pictogram-sprite-sheet.091ce930.svg";